import { render, staticRenderFns } from "./PendenciesUploadInput.vue?vue&type=template&id=4dbc3c40"
import script from "./PendenciesUploadInput.vue?vue&type=script&lang=js"
export * from "./PendenciesUploadInput.vue?vue&type=script&lang=js"
import style0 from "./PendenciesUploadInput.vue?vue&type=style&index=0&id=4dbc3c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports